import React, { useState } from "react";
import PropTypes from "prop-types";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Select } from 'antd';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { DatePicker } from "antd";
import dayjs from 'dayjs';

// Custom toggle for the dropdown
const CustomToggle = React.forwardRef(
  ({ date, onClick, setShow, show }, ref) => {
    return (
      <button
        className="px-2 amt-date-box"
        ref={ref}
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
          setShow(!show);
        }}
      >
        <span>{date}</span>
        <ArrowDropDownIcon />
      </button>
    );
  }
);

CustomToggle.propTypes = {
  date: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

// Custom form inside the dropdown
const CustomForm = React.forwardRef(
  (
    {
      className,
      ariaLabelledBy: labeledBy,
      defaultDisplayOpt,
      defaultTime,
      defaultDate,
      updateDateTime,
      setShow,
    },
    ref
  ) => {
    const today =  new Date();
    
    const [displayOpt, setDisplayOpt] = useState(defaultDisplayOpt || "most_recent");
    const [time, setTime] = useState(defaultTime || 5*60*1000);
    const [date, setDate] = useState(dayjs(defaultDate || `${today.getFullYear()}-${today.getMonth()+1}-${today
      .getDate()
      .toString()
      .padStart(2, "0")} ${today.toLocaleTimeString({
        hour12: false,
      })}`, 'YYYY-MM-DD HH:mm'));
    
    const handleSubmit = (e) => {
      e.preventDefault(); // Prevent default form submission
      if (displayOpt === "most_recent") {
        updateDateTime({time, displayOpt, date});
      } else if (date) {
        const selectedDate = new Date(date); // Assuming 'date' is your original date
        selectedDate.setDate(selectedDate.getDate()); // Add one day
        updateDateTime({time, displayOpt, date: date.format("YYYY-MM-DD HH:mm")} ); // Ensure date is formatted correctly
      }
      setShow(false);
    };

    return (
      <div ref={ref} className={className} aria-labelledby={labeledBy}>
        <Form onSubmit={handleSubmit}>
         {/* <Form.Group className="mb-3" controlId="arrowJumpAmount">
             <Form.Label>Arrow Jump Amount</Form.Label> 
            <Select
            style={{width: "230px"}}
              value={parseInt(time)}
              aria-label="Default select example"
              onChange={(val) => {
                setTime(val);
              }}
            >
             
              <Select.Option value={5*60*1000}>5 Minutes</Select.Option>
              <Select.Option value={10*60*1000}>10 Minutes</Select.Option>
              <Select.Option value={15*60*1000}>15 Minutes</Select.Option>
              <Select.Option value={20*60*1000}>20 Minutes</Select.Option>
              <Select.Option value={30*60*1000}>30 Minutes</Select.Option>
              <Select.Option value={60*60*1000}>60 Minutes</Select.Option>
              <Select.Option value={2*60*60*1000}>2 hours</Select.Option>
              <Select.Option value={3*60*60*1000}>3 hours</Select.Option>
              <Select.Option value={4*60*60*1000}>4 hours</Select.Option>
              <Select.Option value={6*60*60*1000}>6 hours</Select.Option>
              <Select.Option value={12*60*60*1000}>12 hours</Select.Option>
              <Select.Option value={24*60*60*1000}>24 hours</Select.Option>
            </Select>
          </Form.Group>*/}

          <Form.Group className="mb-3" controlId="displayMostRecentData">
            {/* <Form.Check
              type="radio"
              name="displayOpt"
              checked={displayOpt === "most_recent"}
              value="most_recent"
              onChange={(e) => setDisplayOpt(e.target.value)}
              label="Display most recent data"
            /> */}
            <Form.Check
              type="radio"
              name="displayOpt"
              checked={displayOpt === "specific_date"}
              value="specific_date"
              onChange={(e) => setDisplayOpt(e.target.value)}
              label="Jump to a specific time …"
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formBasicDatePicker">
            <DatePicker
              showTime
              allowClear={false}
              value={date}
              onChange={(date) => {
                setDate(date);
              }}
              disabled={displayOpt !== "specific_date"}
              className="form-control" // Apply Bootstrap styling
              style={{ width: "100%" }} // Ensure it fits well
            />
          </Form.Group>

          <Button variant="primary bg-black" type="submit" size="sm">
            Update Time
          </Button>
        </Form>
      </div>
    );
  }
);

CustomForm.propTypes = {
  className: PropTypes.string,
  ariaLabelledBy: PropTypes.string,
  defaultDisplayOpt: PropTypes.string,
  defaultTime: PropTypes.string,
  defaultDate: PropTypes.string
};

// Main component
function AMTDateBox({ date, defaultDisplayOpt, defaultTime, defaultDate, updateDateTime }) {
  const [show, setShow] = useState(false);
  return (
    <Dropdown show={show}>
      <Dropdown.Toggle
        as={CustomToggle}
        setShow={setShow}
        show={show}
        date={date}
        id="dropdown-custom-date-components"
      >
        {date}
      </Dropdown.Toggle>

      <Dropdown.Menu
        as={CustomForm}
        className="p-4 amt-date-box-show"
        updateDateTime={updateDateTime}
        setShow={setShow}
        defaultDisplayOpt= {defaultDisplayOpt}
        defaultTime={defaultTime}
        defaultDate={defaultDate}
      ></Dropdown.Menu>
    </Dropdown>
  );
}

AMTDateBox.propTypes = {
  date: PropTypes.string.isRequired,
  defaultDisplayOpt: PropTypes.string,
  defaultTime: PropTypes.number,
  defaultDate: PropTypes.string
};

export default AMTDateBox;
